<template>
  <div class="bottom-navbar">
    <QueueButton variant="cancel" class="w-auto action-cancel-button" @click="emitCancel">
        <img src="/icons/back2.svg" class="del" />
    </QueueButton>

    <slot></slot>
  </div>
</template>

<script>
import QueueButton from '@/components/QueueButton.vue'

export default {
    methods: {
        emitCancel() {
            this.$emit('cancel');
        }
    },
    components: {
        QueueButton
    }
}
</script>

<style scoped>
.bottom-navbar {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    background: #1d1d1b;
    padding: 1.3vh 2.5vh 2.7vh;
    z-index: 10;
    display: flex;
    justify-content: space-between;
}

 

 
</style>